<template>
<!-- :sort-method="(a,b)=>{return sortMethod(a,b,item.dataIndex)}" -->
	<el-table-column :width="widthValue(item)" 
		align="center" :index="index" :show-overflow-tooltip='true' :fixed='fixed'
		:sortable="item.sortable"
		:sort-method="(a,b)=>{return sortMethod(a,b,item.dataIndex,item.sortName)}"
	>
		<template #header="{ column, $index }">
			<el-checkbox v-model="allChecked" @change="allCheckedChange" :label="item.allText || '全选'" v-if="item.columnType == 'check'" ></el-checkbox>
			<span v-if="item.columnType == 'index'">序号</span>
			<span v-if="item.columnType!='check' && item.columnType!='index' && !item.renderToHtml">{{headerRender(item.headerLabel,item.headerRender)}}</span>
			<span v-if="item.columnType!='check' && item.columnType!='index' && item.renderToHtml"
			v-html="htmlRender(item.headerLabel, item.headerRender, null, column, $index)"></span>
			<!-- <div class="checkColumn" v-if="item.columnType == 'check'">
				<input type="checkbox" v-model="allChecked" @change="allCheckedChange" />
				<div class="text">全选</div>
			</div> -->
			<!-- <input type="checkbox" v-model="allChecked" @change="allCheckedChange" label="全选" />
			<div class="text">全选</div> -->
			<!-- 	<div class="checkColumn" v-if="item.columnType == 'index'">
				序号
			</div>
			<div class="checkColumn" v-if="item.columnType!='check' && item.columnType!='index' && !item.renderToHtml">
				{{headerRender(item.headerLabel,item.headerRender)}}
			</div>
			<div class="checkColumn" v-if="item.columnType!='check' && item.columnType!='index' && item.renderToHtml"
				v-html="htmlRender(item.headerLabel, item.headerRender, null, column, $index)">
			</div> -->
		</template>
		<!-- <template #header v-if="item.columnType == 'index'">
			序号
		</template> -->
		<!-- <template #header v-if="item.columnType!='check' && item.columnType!='index' && !item.renderToHtml">
			{{headerRender(item.headerLabel,item.headerRender)}}
		</template> -->
		<!-- <template #header v-if="item.columnType!='check' && item.columnType!='index' && item.renderToHtml"
			v-html="htmlRender(item.headerLabel, item.headerRender, null, column, $index)">
		</template> -->

		<template v-if="!item.groups || item.groups.length == 0" #default="{ row, column, $index }">
			<div class="cell" v-if="item.columnType=='check'">
				<input type="checkbox" v-model="row.checked" @change="checkColumnChange(row.checked, $index, row)" />
			</div>
			<div class="cell" v-if="item.columnType=='index'">
				{{indexValue($index)}}
			</div>
			<div class="cell" v-if="item.columnType!='check' && item.columnType!='index'">
					<!-- 将data作为作用域数据传递 -->
				<slot :name="item.slot" :data="{row, column, $index}">
					<span v-if="(!row.editStatus || !item.editable) && item.renderToHtml"
						v-html="htmlRender(row[item.dataIndex], item.dataRender, row, column,$index)">
					</span>


					<!-- <span v-if="(!row.editStatus || !item.editable) && !item.renderToHtml">
						{{ dataRender(row[item.dataIndex],item.dataRender, row, column,$index) }}
					</span> -->
					<span v-if="(!row.editStatus || !item.editable) && !item.renderToHtml"
						v-html="dataRender(row[item.dataIndex],item.dataRender, row, column,$index)">
					</span>
					<template v-if="row.editStatus && item.editable === true">
						<slot :name="item.editSlot" :data="{row, column, $index, item}">
							<field :type="item.editType" class="editInput" v-model:value="row[item.dataIndex]"
								:showLabel="false" :fieldData="item.fieldData"
								:selectRemoteSearchData="item.selectRemoteSearchData"
								:showSelectPagenation="item.showSelectPagenation" :rangeSeparator="item.rangeSeparator"
								:selectValueFn="item.selectValueFn" :tabelRow="row" :formData="row"
								:clearable="item.clearable" :refKey="item.refKey" :rows="item.rows"></field>
						</slot>
					</template>
				</slot>
			</div>
		</template>
		<!-- <template v-if="item.groups && item.groups.length > 0">
			<tabel-column v-for="(itemChild,indexChild) in item.groups" :key="`tableColumChild${indexChild}`"
				:index="index" :item="itemChild" :allCheckedPop="allCheckedPop" @allCheckedChange="allCheckedChange"
				@checkColumnChange="checkColumnChange">
				<template v-slot:[itemChild.slot]="$data">
					<slot :name="itemChild.slot" :data="$data.data"></slot>
				</template>
			</tabel-column>
		</template> -->
	</el-table-column>
</template>

<script>
	import field from "@/components/textField.vue"
	import {
		defineComponent,
		reactive,
		toRefs,
		watch
	} from "vue"

	export default defineComponent({
		name: "tabelColumn",
		components: {
			field
		},
		props: {
			fixed:{
				type:String,
				default:null,
			},
			item: {
				type: Object,
				default () {
					return {}
				}
			},
			index: {
				type: Number,
				default: 0
			},
			allCheckedPop: {
				type: Boolean,
				default: false
			},
			selectRemoteSearchData: {
				type: Function,
				default: null
			}
		},
		emits: ["allCheckedChange", "checkColumnChange"],
		setup(props, {
			emit
		}) {
			let data = reactive({
				allChecked: false
			})

			let methods = {
				isNumber(flag){
			return	typeof(flag)=='number' && !isNaN(flag)
		},
		isNumOrDate(flag){
			const str=flag+''
			const arr=str.split('-')
			const aaa=	arr.some(item=>methods.isNumber(item*1))
			// console.log(aaa,'ssss')
			return aaa
		},
		sortChinese(arr, dataLeven){
			const getValue = (option) => {
				if (!dataLeven) return option
				let data = option
				dataLeven.split(".").filter((item)=>{data = data[tiem]})
				return data+ ""
			}
			arr.sort(function (item1, item2) {
				return getValue(item1).localeCompare(getValue(item2), 'zh-CN');
			})
		},
		// function sortChinese (arr, dataLeven) { // 参数：arr 排序的数组; dataLeven 数组内的需要比较的元素属性
		// 		//* 获取数组元素内需要比较的值 */
			// 	function getValue (option) { // 参数： option 数组元素
			// 		if (!dataLeven) return option
			// 		var data = option
			// 		dataLeven.split('.').filter(function (item) {
			// 			data = data[item]
			// 		})
			// 		return data + ''
			// 	}
			// 	arr.sort(function (item1, item2) {
			// 	return getValue(item1).localeCompare(getValue(item2), 'zh-CN');
			// 	})
		// }

		sortMethod(a,b,propName,sortName){
			// debugger
			if ( sortName ) {
				return a[sortName]?.localeCompare(b[sortName], 'zh-CN');
			}
			if (propName == "RepairUserName") {
				return a.RepairUserName?.localeCompare(b.RepairUserName, 'zh-CN');
				// console.log("A--",a)
				// console.log("B--",b)
				// console.log("val-",val)
				// a.localeCompare(b)
				// return
			}
			if (propName == "LinkMan") {
				// console.log('aaaa',a,a.LinkMan,)
				return a.LinkMan?.localeCompare(b.LinkMan, 'zh-CN');
				// console.log("A--",a)
				// console.log("B--",b)
				// console.log("val-",val)
				// a.localeCompare(b)
				// return
			}
			if (propName == "IsStatus") {
				return a.IsStatus?.localeCompare(b.IsStatus, 'zh-CN');
			}
			
			const ap=a[propName]+''
			const bp=b[propName]+''
				
			if(methods.isNumOrDate(ap) || methods.isNumOrDate(bp)){
				const astr=ap.split('-').join('')
				const bstr=bp.split('-').join('')
				// debugger
					if(astr*1>bstr*1){
						return -1//升序
					} else{
						return 1
					} 
			}else{
				const astr=a[propName]+''
				const bstr=b[propName]+''
				if(astr.length>bstr.length){
					return -1
				}else{
					return 1
				}
				// console.log('字符串',astr,bstr)
			}
		},
				htmlRender(value, renderFn, row, column, $index) {
					if (renderFn) {
						return renderFn(value, {
							row,
							column,
							$index
						})
					} else {
						return value
					}
				},
				allCheckedChange() {
					emit("allCheckedChange", data.allChecked)
				},
				checkColumnChange(checked, index, row) {
					emit("checkColumnChange", {
						checked,
						index,
						row
					})
				},
				indexValue(value) {
					return ((value + 1) + '').PadLeft(2, '0');
				},
				widthValue(item) {
					if (item.columnType == "check" || item.columnType == "index") {
						return 70
					} else if (item.width) {
						return item.width
					} else {
						return null
					}
				},
				dataRender(value, renderFn, row, column, $index) {
					if (renderFn) {
						return renderFn(value,{
							row,
							column,
							$index
						})
					} else {
						return value
					}
				},
				headerRender(value, renderFn) {
					if (renderFn) {
						return renderFn(value)
					} else {
						return value
					}
				}
			}

			watch(() => {
				return props.allCheckedPop
			}, (newValue) => {
				data.allChecked = newValue
			})

			return {
				...toRefs(data),
				...methods
			}
		}
	})
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";

	.userColumnClass {
		flex: 1;
	}

	.checkColumn {
		display: flex;
		@include font_family("font_family");
		font-size: 16px;
		line-height: 16px;
		@include font_color("tabel-header-content-font-color");
		align-items: center;
		align-content: center;
		justify-content: center;
		height: 40px;

		.text {
			margin-left: 6px;
		}
	}

	.cell {
		// 表格单元格得样式
		// display: flex;
		
		width: 100%;
		// height: 100%;
		overflow: hidden;
		white-space:nowrap;
		text-overflow: ellipsis;
		// text-overflow: -o-ellipsis-lastline;
		text-align: center;
		padding:0 !important;
	
 
		.editInput {
			width: 100%;
			height: 100%;
		}
	}
</style>
